var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 90 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,0H0V60z",
    fill: "#003580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,60H90V0z",
    fill: "#009543"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,60 90,0",
    stroke: "#fff",
    strokeWidth: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,60 90,0",
    stroke: "#d21034",
    strokeWidth: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffce00",
    transform: "translate(18,16.34148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M0,10 1.552914,5.795555H-1.552914z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    transform: "rotate(270)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r4",
    transform: "rotate(60)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.5,
    stroke: "#003580"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/na.4322251d80b513d70f0aa9cac4864272.svg";
export { ForwardRef as ReactComponent };